import { React, classNames, withStyles, StyledProps, CentricTheme, ThemedProps } from '@api'
import { Card, CardContent, CardMedia, Typography, withTheme } from '@material-ui/core'

const styles = (theme: CentricTheme) => ({
  container: {
    position: 'relative'
  },
  root: {
    width: 200,
    maxHeight: 92,
    cursor: 'pointer',
    display: 'flex',
    padding: theme.spacing(),
    '&:last-child': {
      padding: 8
    }
  },
  media: {
    flex: '35%',
    display: 'flex',
    backgroundSize: 'contain'
  },
  content: {
    flex: '65%',
    paddingLeft: theme.spacing(),
    maxWidth: '65%'
  },
  cardInfo: {
    padding: theme.spacing(),
    borderTop: `1px solid ${theme.colors.grey5}`
  },
  status: {
    padding: theme.spacing()
  },
  statusAndTag: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 20
  },
  subHeading: {
    marginTop: theme.spacing() / 2,
    height: 48
  },
  description: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  '@keyframes loading': {
    '0%': {backgroundColor: theme.colors.grey2},
    '20%': {backgroundColor: theme.colors.grey3},
    '40%': {backgroundColor: theme.colors.grey4},
    '60%': {backgroundColor: theme.colors.grey5},
    '85%': {backgroundColor: theme.colors.grey4},
    '100%': {backgroundColor: theme.colors.grey3}
  },
  loading: {
    animationDuration: `1s`,
    animationName: `loading`,
    animationIterationCount: `infinite`,
    animationTimingFunction: 'ease-out'
  },
  disabled: {
    width: '100%',
    height: 92,
    position: 'absolute',
    zIndex: 1,
    background: 'rgba(0, 0, 0, 0.25)',
    pointerEvents: 'none'
  },
  colorDescription: {
    fontSize: 10
  }
})

interface MyProps extends StyledProps, ThemedProps {
  image: string,
  title: string,
  label?: string,
  labelcolor?: string,
  raised?: boolean
  loading?: boolean
  onClick?: (e) => void
  active?: boolean
  mmc?: string,
  color?: string,
  material?: string
}

@(withStyles as any)(styles)
export class MediaCardList extends React.Component<MyProps> {
  static defaultProps = {
    active:   true,
    color:    'Color',
    material: 'Material',
    mmc:      'MMC'
    }

  render() {

    const {props: {classes, image, title, label, labelcolor, mmc, color, material, raised, loading, onClick, active}} = this

    return (
      <div className={classes.container}>
        {!active && <div className={classes.disabled}/>}
        <Card raised={raised} onClick={onClick}>
          <CardContent classes={{root: classes.root}}>
            {loading
             ? <div className={`${classes.media} ${classes.loading}`}/>
             : <CardMedia image={image} title={mmc} className={classes.media} style={{opacity: active ? 1 : 0.7}}/>}
            <div className={classes.content}>
              <div className={`${classes.statusAndTag} ${loading ? classes.loading : ''}`}>
                {!loading && <Typography variant='caption'>{title}</Typography>}
                {!loading && label && labelcolor &&
                <Typography variant='caption' style={{
                  backgroundColor: labelcolor,
                  padding:         '2px 4px',
                  lineHeight:      1.4,
                  borderRadius:    2,
                  color:           'white'
                }}>
                  {label}</Typography>}
              </div>
              <div>
                <Typography data-loading={loading} variant='body1' className={classes.description}>{mmc && mmc.toUpperCase()}</Typography>
                <Typography data-loading={loading} variant='body1' className={`${classes.description} ${classes.colorDescription}`}>{material && material.toUpperCase()}</Typography>
                <Typography data-loading={loading} variant='body1' className={`${classes.description} ${classes.colorDescription}`}>{color && color.toUpperCase()}</Typography>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/MediaCardList.tsx